module.exports = __webpack_public_path__ + "static/media/car-hatchback-5.9a1a5141.png";